import { Server } from '../constants/server';

const ERP_PHOTO_PATH = '/data/v1/upload/products/erp/'

// Product photo URL. CMS products store a bare filename on the CMS site;
// ERP-created products store an absolute URL to an image uploaded in the ERP.
// That URL carries the host of the server that saved it (API_SERVER_URL), which
// may not be reachable from here, so ERP uploads load from this portal's own API server.
export const getProductImageUrl = (path) => {
    if (!/^https?:\/\//i.test(path ?? '')) return `https://leoprinting.nl/files/photos/${path}`
    const erpPhotoIndex = path.indexOf(ERP_PHOTO_PATH)
    if (erpPhotoIndex === -1 || !Server.BaseUrl) return path
    return Server.BaseUrl.replace(/\/+$/, '') + path.slice(erpPhotoIndex)
}
